import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class PayrollEmployeeModel extends BaseModel {

    constructor() {
        super({ 
                name: "payrollEmployee",
                tableName: 'users', 
                label: "Bảng lương nhân viên", 
                display_key: 'fullname', 
                default_order: { key: 'created_at', direction: 'asc' } }, 
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "String",
                width: 4,
                class: "center",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
            },
            id: { 
                name: 'id', 
                type: "Uuid", 
                label: 'ID', 
                primaryKey: true, 
                display: false
            },
            fullname: {
                name: 'fullname', 
                type: "String",
                label: 'Họ và tên TĐV',
                width: 10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false,
            },
            areas: {
                refs: 'areas {id code} ',
                display: false
            },
            display_areas: {
                name: 'display_areas',
                label: 'Mã khu vực',
                width : 10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_areas = '';
                    if(data.areas !== undefined && data.areas !== null){
                        data.display_areas = data.areas.code;
                    }
                }
            },
            doc_doc_type1_ref: {
                refs: 'view_payroll_type1_aggregate {aggregate {count sum {amount_salary}}}',
                display: false
            },
            total_doc_type1: {
                name: 'total_doc_type1', 
                type: "Computed",
                label: 'Loại 1 (thường)',
                width: 8,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.total_doc_type1 = data.view_payroll_type1_aggregate.aggregate.count
                },
            },
            doc_doc_type1_late_ref: {
                refs: 'view_payroll_type1_late_aggregate {aggregate {count sum {amount_salary}}}',
                display: false
            },
            total_doc_type1_late: {
                name: 'total_doc_type1_late', 
                type: "Computed",
                label: 'Loại 1 (trễ)',
                width: 6,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.total_doc_type1_late = data.view_payroll_type1_late_aggregate.aggregate.count
                },
            },
            doc_doc_type2_ref: {
                refs: 'view_payroll_type2_aggregate {aggregate {count sum {amount_salary}}}',
                display: false
            },
            total_doc_type2: {
                name: 'total_doc_type2', 
                type: "Computed",
                label: 'Loại 2 (thường)',
                width: 8,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.total_doc_type2 = data.view_payroll_type2_aggregate.aggregate.count
                },
            },
            doc_doc_type2_late_ref: {
                refs: 'view_payroll_type2_late_aggregate {aggregate {count sum {amount_salary}}}',
                display: false
            },
            total_doc_type2_late: {
                name: 'total_doc_type2_late', 
                type: "Computed",
                label: 'Loại 2 (trễ)',
                width: 6,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.total_doc_type2_late = data.view_payroll_type2_late_aggregate.aggregate.count
                },
            },
            doc_doc_type3_ref: {
                refs: 'view_payroll_type3_aggregate {aggregate {count}}',
                display: false
            },
            total_doc_type3: {
                name: 'total_doc_type3', 
                type: "Computed",
                label: 'Loại 3 (thường)',
                width: 8,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.total_doc_type3 = data.view_payroll_type3_aggregate.aggregate.count
                },
            },
            doc_doc_type3_late_ref: {
                refs: 'view_payroll_type3_late_aggregate {aggregate {count}}',
                display: false
            },
            total_doc_type3_late: {
                name: 'total_doc_type3_late', 
                type: "Computed",
                label: 'Loại 3 (trễ)',
                width: 6,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.total_doc_type3_late = data.view_payroll_type3_late_aggregate.aggregate.count
                },
            },
            doc_doc_type4_ref: {
                refs: 'view_payroll_type4_aggregate {aggregate {count}}',
                display: false
            },
            total_doc_type4: {
                name: 'total_doc_type4', 
                type: "Computed",
                label: 'Loại 4 (trả tòa)',
                width: 6,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.total_doc_type4 = data.view_payroll_type4_aggregate.aggregate.count
                },
            },
            doc_doc_type5_ref: {
                refs: 'view_payroll_type5_aggregate {aggregate {count sum {amount_salary}}}',
                display: false
            },
            total_doc_type5: {
                name: 'total_doc_type5', 
                type: "Computed",
                label: 'Loại 5 (đi tỉnh)',
                width: 6,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    data.total_doc_type5 = data.view_payroll_type5_aggregate.aggregate.count
                },
            },
            // doc_salary_type1_ref: {
            //     refs: 'view_tdv_total_doc_confirmed_aggregate {aggregate {count}}',
            //     display: false
            // },
            total_salary_type1: {
                name: 'total_salary_type1', 
                type: "Computed",
                label: 'Số tiền loại 1 (thường)',
                width: 8,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    // console.log(data.view_payroll_type1_aggregate.aggregate.sum.amount_salary)
                    if (data.view_payroll_type1_aggregate.aggregate.sum.amount_salary == null) data.total_salary_type1 = 0;
                    else data.total_salary_type1 = data.view_payroll_type1_aggregate.aggregate.sum.amount_salary;
                },
            },
            // doc_salary_type1_late_ref: {
            //     refs: 'view_tdv_total_doc_confirmed_aggregate {aggregate {count}}',
            //     display: false
            // },
            total_salary_type1_late: {
                name: 'total_salary_type1_late', 
                type: "Computed",
                label: 'Số tiền loại 1 (trễ)',
                width: 8,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    if (data.view_payroll_type1_late_aggregate.aggregate.sum.amount_salary == null) data.total_salary_type1_late = 0;
                    else data.total_salary_type1_late = data.view_payroll_type1_late_aggregate.aggregate.sum.amount_salary;
                },
            },
            // doc_salary_type2_ref: {
            //     refs: 'view_tdv_total_doc_confirmed_aggregate {aggregate {count}}',
            //     display: false
            // },
            total_salary_type2: {
                name: 'total_salary_type2', 
                type: "Computed",
                label: 'Số tiền loại 2 (thường)',
                width: 8,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    if (data.view_payroll_type2_aggregate.aggregate.sum.amount_salary == null) data.total_salary_type2 = 0;
                    else data.total_salary_type2 = data.view_payroll_type2_aggregate.aggregate.sum.amount_salary;
                },
            },
            // doc_salary_type2_late_ref: {
            //     refs: 'view_tdv_total_doc_confirmed_aggregate {aggregate {count}}',
            //     display: false
            // },
            total_salary_type2_late: {
                name: 'total_doc_confirmed', 
                type: "Computed",
                label: 'Số tiền loại 2 (trễ)',
                width: 8,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    if (data.view_payroll_type2_late_aggregate.aggregate.sum.amount_salary == null) data.total_salary_type2_late = 0;
                    else data.total_salary_type2_late = data.view_payroll_type2_late_aggregate.aggregate.sum.amount_salary;
                },
            },
            // doc_total_salary_type12_ref: {
            //     refs: 'view_tdv_total_doc_confirmed_aggregate {aggregate {count}}',
            //     display: false
            // },
            total_salary_type12: {
                name: 'total_salary_type12', 
                type: "Computed",
                label: 'Tổng tiền (Loại 1+2)',
                width: 8,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    let salary1 = data.view_payroll_type1_aggregate.aggregate.sum.amount_salary !== null && data.view_payroll_type1_aggregate.aggregate.sum.amount_salary || 0;
                    let salary2 = data.view_payroll_type2_aggregate.aggregate.sum.amount_salary !== null && data.view_payroll_type2_aggregate.aggregate.sum.amount_salary || 0;
                    var salary1_late = 0;
                    if (!(data.view_payroll_type1_late_aggregate.aggregate.sum.amount_salary == null))
                    {
                        salary1_late = data.view_payroll_type1_late_aggregate.aggregate.sum.amount_salary;
                    }
                    var salary2_late = 0;
                    if (!(data.view_payroll_type2_late_aggregate.aggregate.sum.amount_salary == null))
                    {
                        salary2_late =  data.view_payroll_type2_late_aggregate.aggregate.sum.amount_salary;
                    }


                    data.total_salary_type12 = parseFloat(salary1) + parseFloat(salary2) + parseFloat(salary1_late) + parseFloat(salary2_late);
                },
            },
            // doc_total_salary_type5_ref: {
            //     refs: 'view_tdv_total_doc_confirmed_aggregate {aggregate {count}}',
            //     display: false
            // },
            total_salary_type5: {
                name: 'total_salary_type5', 
                type: "Computed",
                label: 'Tổng tiền loại 5 (đi Tỉnh)',
                width: 10,
                class: "center",
                // filter: { type: 'input', match: 'contains'},
                // display: false
                computed: (data) => {
                    if (data.view_payroll_type5_aggregate.aggregate.sum.amount_salary == null) data.total_salary_type5 = 0;
                    else data.total_salary_type5 = data.view_payroll_type5_aggregate.aggregate.sum.amount_salary;
                },
            },
            
        },)
    }

}